import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { IoPersonAddSharp } from "react-icons/io5";
import CreateMeeting from "../../Modal/Meetings/CreateMeeting";
import { MeetingService } from "../../services/MeetingService";
import { toast } from "react-toastify";
import AddMember from "../../Modal/Meetings/AddMembers";
import Button from "@mui/material/Button";
import { LuCalendarDays } from "react-icons/lu";
const MeetingList = () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [meetings, setMeetings] = useState([]);
  const [selectedMeetingId, setSelectedMeetingId] = useState(null);
  const [meetingToDelete, setMeetingToDelete] = useState(null);
  const [selectedDate, setSelectedDate] = useState(() => {
    return new Date().toISOString().split("T")[0];
  });
  const formatDisplayDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };


  useEffect(() => {
    
  const fetchMeetings = async (date = selectedDate) => {
    try {
      const response = await MeetingService.getMeeting(date);
      setMeetings(response.data);
    } catch (error) {
      toast.error("Failed to get Meeting List");
    }
  };
    fetchMeetings();
  }, [selectedDate]);

  const handleAddMemberClick = (id) => {
    setSelectedMeetingId(id);
    // console.log(id);
    setShowAddModal(true);
  };

  const handleDelete = (id) => {
    setMeetingToDelete(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await MeetingService.deleteMeeting(meetingToDelete);
      if(response){
        setShowDeleteModal(false);
        toast.success("Meeting Deleted");
        setMeetings((prev)=>prev.filter((item) => item.id !== meetingToDelete));
        setMeetingToDelete(null);
      }

    } catch (error) {
      toast.error("Failed to delete Meeting");
    }
  };

  return (
    <div className="mt-3 h-[40vh] w-full rounded-xl shadow-lg bg-white p-5 border border-gray-200">
  {/* Header */}
  <div className="flex flex-wrap gap-3 justify-between items-center mb-5">

    <h2 className="font-bold text-lg bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent flex items-center gap-2">
      <LuCalendarDays className="text-xl text-blue-700" /> Meetings
    </h2>

    <div className="flex items-center gap-3 w-full sm:w-auto justify-between sm:justify-start">

      <input
        type="date"
        className="border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none "
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
      />
      <button
        onClick={() => setShowCreateModal(true)}
        className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-full w-9 h-9 flex items-center justify-center text-lg shadow hover:from-blue-700 hover:to-indigo-700 transition"
      >
        <FaPlus />
      </button>
    </div>
  </div>

  {/* Date Label */}
  <h1 className="text-sm text-gray-600 mb-3">
    Meetings on:{" "}
    <span className="font-medium text-gray-800">
      {formatDisplayDate(selectedDate)}
    </span>
  </h1>

  {/* Meeting List */}
  <div
    className="mt-4 h-[15vh] overflow-y-auto pr-1 space-y-3"
    style={{ scrollbarWidth: "none" }}
  >
    {meetings.length === 0 ? (
      <p className="text-gray-500 italic">
        No meetings scheduled for {formatDisplayDate(selectedDate)}.
      </p>
    ) : (
      <ul className="space-y-2">
        {meetings.map((meeting, index) => (
          <li
            key={meeting.id}
            className="flex justify-between items-center bg-gray-50 p-3 rounded-lg shadow-sm hover:shadow-md transition"
          >
            <div>
              <p className="font-medium text-gray-800">
                {index + 1}. {meeting.title}
              </p>
              <span className="text-xs text-gray-500">
                ⏰{" "}
                {new Date(`1970-01-01T${meeting.time}`).toLocaleTimeString(
                  "en-US",
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  }
                )}
              </span>
            </div>
            <div className="flex gap-2">
              <button
                className="bg-blue-500 text-white p-2 rounded hover:bg-blue-600 transition"
                onClick={() => handleAddMemberClick(meeting.id)}
              >
                <IoPersonAddSharp size={16} />
              </button>
              <button
                className="text-red-500 hover:text-red-600 p-2 rounded-full hover:bg-red-50 transition"
                onClick={() => handleDelete(meeting.id)}
              >
                <FaTrash size={16} />
              </button>
            </div>
          </li>
        ))}
      </ul>
    )}
  </div>

      {
        showCreateModal && (
          <CreateMeeting
        isOpen={showCreateModal}
        onClose={() => setShowCreateModal(false)}
        setMeetings={setMeetings}
      />
        )
      }
      {
        showAddModal && (
           <AddMember
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        meetingId={selectedMeetingId}
      />)
      }
     
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 transition-opacity duration-300">
          <div className="bg-white w-full max-w-sm mx-4 p-6 rounded-2xl shadow-xl border border-gray-200">
            <h2 className="text-lg font-semibold text-primary mb-3">
              Delete Meeting
            </h2>
            <p className="text-[15px] text-primary mb-6">
              Are you sure you want to delete this meeting? 
            </p>
            <div className="flex justify-end gap-3">
      
              <Button
             onClick={() => {
                  setShowDeleteModal(false);
                  setMeetingToDelete(null);
                }}
            variant="outlined"
            className="  !text-gray-700 !bg-white !capitalize !w-[100px] !font-medium  !border !border-gray-300"
          >
            Cancel
          </Button>
          <Button
            onClick={confirmDelete}
            variant="contained"
            className=" !bg-zinc-800 !capitalize !w-[100px] !font-medium !text-white hover:!bg-red-700 "
          >
             Delete
          </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MeetingList;
